import { useContext } from "react";
import { AuthContext } from "./AuthContext";

// Доступ к контексту авторизации; вне <AuthProvider> — ошибка сразу.
export default function useAuth() {
    const context = useContext(AuthContext);
    if (context === null) {
        throw new Error('useAuth должен использоваться внутри <AuthProvider>');
    }
    return context;
}
